import { Attachment } from "../components/attachment/Attachment";
import { DomEvent } from "./DomEvent";
import { Event, EventListener } from "./Event";

export interface FileRemovalListener extends EventListener<FileRemovalEvent> {
}

export class FileRemovalEvent extends Event<Attachment> {
    private fileName: string = null;

    constructor(component: Attachment, fileName: string, domEvent?: DomEvent) {
        super(component, domEvent);
        this.fileName = fileName;
    }

    public getFileName(): string {
        return this.fileName;
    }
}
